let userAgent;
(function test(doc, win) {
  // console.log(333)
  if(/Android|webOS|iPhone|iPod|BlackBerry|ipad/i.test(navigator.userAgent)) {
    userAgent = 'mobile'
    var deviceWidth = document.documentElement.clientWidth >= 1024 ? 1024 : document.documentElement.clientWidth - 50
    document.getElementsByTagName('html')[0].style.cssText = 'font-size:' + deviceWidth / 10.24 + 'px !important'
  }else {
    userAgent = 'pc'
    var deviceWidth = document.documentElement.clientWidth >= 1024 ? 1024 : document.documentElement.clientWidth
    document.getElementsByTagName('html')[0].style.cssText = 'font-size:' + deviceWidth / 10.24 + 'px !important'
  }

}(document, window))
// 设置 rem 函数


window.onresize = function () {
  // console.log(2222)
  if(/Android|webOS|iPhone|iPod|BlackBerry|ipad/i.test(navigator.userAgent)) {
    userAgent = 'mobile'
    var deviceWidth = document.documentElement.clientWidth >= 1024 ? 1024 : document.documentElement.clientWidth - 50
    document.getElementsByTagName('html')[0].style.cssText = 'font-size:' + deviceWidth / 10.24 + 'px !important'
  }else {
    userAgent = 'pc'
    var deviceWidth = document.documentElement.clientWidth >= 1024 ? 1024 : document.documentElement.clientWidth
    document.getElementsByTagName('html')[0].style.cssText = 'font-size:' + deviceWidth / 10.24 + 'px !important'
  }
}
export default {
  userAgent(){
    if(userAgent === 'mobile'){
      return 'mobile';
    }else{
      return 'pc';
    }
  }
}




// WEBPACK FOOTER //
// ./src/utils/lib/index.js